import React from 'react'
import injectSheet from 'react-jss'
import styles from './action-add-work.styles'
import CheckIcon from 'react-icons/lib/fa/plus'

const ActionAddWork = ({ classes, id, name, timestamp }) => {
  return (
    <div className={classes.container}>
      <span className={classes.icon}>
        <CheckIcon />
      </span>{' '}
      <div>
        <strong className={classes.name}>{name}</strong>&nbsp;added a piece of
        work {timestamp} ago
      </div>
    </div>
  )
}

export default injectSheet(styles)(ActionAddWork)
